import React from "react";
import { Box, Typography } from "@mui/material";
import { COLORS } from "../../styles/uiConstants";

export const TILE_SX = {
  border: `1px solid ${COLORS.slate200}`,
  borderRadius: 2,
  px: 2,
  py: 1.5,
  bgcolor: COLORS.white,
  minHeight: 78,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  transition: "border-color 0.15s",
  "&:hover": { borderColor: COLORS.slate300 },
};

/**
 * InfoTile — icon + uppercase label + content tile.
 * Klinik detay sayfasındaki tasarım dilini paylaşan tüm form/drawer'larda kullanılır.
 *
 * @param {React.ReactElement} icon
 * @param {string} label
 * @param {React.ReactNode} children
 * @param {boolean} [fullWidth] - grid'de tüm sütunları kapla
 * @param {object} [sx]
 */
export default function InfoTile({ icon, label, children, fullWidth, sx = {} }) {
  return (
    <Box sx={{ ...TILE_SX, gridColumn: fullWidth ? "1 / -1" : "auto", ...sx }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mb: 0.75, color: COLORS.slate400 }}>
        {icon && React.cloneElement(icon, { sx: { fontSize: 14 } })}
        <Typography sx={{
          fontSize: 11, fontWeight: 700, color: COLORS.slate500,
          letterSpacing: "0.05em", textTransform: "uppercase",
        }}>
          {label}
        </Typography>
      </Box>
      <Box>{children}</Box>
    </Box>
  );
}

export const tileInputProps = (canEdit = true) => ({
  disableUnderline: !canEdit,
  sx: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: COLORS.slate800,
    "&:before": { borderBottom: canEdit ? undefined : "none !important" },
    "&:hover:not(.Mui-disabled):before": { borderBottom: canEdit ? undefined : "none !important" },
  },
});
